import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import styled from 'styled-components'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import { Container } from '../../../assets/styles/GlobalStyle'
import Button from '../../../components/v2/buttons/Button'
//
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import api from '../../../api'
import DoubleRightIcon from '../../../assets/icons/JSX/DoubleRightIcon'
import CustomLink from '../../../components/CustomLink'
import Loader from '../../../components/Loader'
import BaseModal from '../../../components/v2/modals/BaseModal'
import { useAppSelector } from '../../../store'
import { AppState } from '../../../store/appSlice'
import { Link } from 'react-router-dom'
import { Swiper, SwiperSlide } from 'swiper/react'
import { A11y, Autoplay, Navigation } from 'swiper/modules'
import CompanyCard from '../../../components/CompanyCard'
import ShortLeftArrow from '../../../assets/icons/JSX/ShortLeftArrow'
import ShortRightArrow from '../../../assets/icons/JSX/ShortRightArrow'
import AiModalCard from '../../../components/AiModal'

interface ServiceSectionWrapperProps {
  children: React.ReactNode
  icon?: React.ReactNode
}

const ServiceSectionWrapper = ({ children, icon }: ServiceSectionWrapperProps) => (
  <ServiceSection>
    {icon}
    <Container>{children}</Container>
  </ServiceSection>
)

//
const ProductDetail = () => {
  //
  const { t } = useTranslation()
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const { type } = useParams()
  //
  const [selectedCovered, setSelectedCovered] = useState<number | null>(null)
  //
  const navigate = useNavigate()
  //
  const { data: product, isLoading: isProductLoading } = api.useGetProductDetailInfoByTypeQuery(type as string, {
    skip: !type ? true : false,
  })
  //
  const { data: companies, isLoading: isCompaniesLoading } = api.useGetProductDetailsCompanyByTypeQuery(
    type as string,
    {
      skip: !type ? true : false,
    },
  )

  const brakePoints = {
    1200: {
      slidesPerView: 3,
      spaceBetween: 24,
    },
    1350: {
      slidesPerView: 3,
      spaceBetween: 24,
    },
    1650: {
      slidesPerView: 4,
      spaceBetween: 40,
    },
  }

  const [isAiModalCardVisible, setIsAiModalCardVisible] = useState(false)

  //
  // scroll to top
  useEffect(() => {
    window.scrollTo(0, 0)
    //
    return () => {}
  }, [type])
  //
  const MainLoading = isCompaniesLoading || isProductLoading
  //
  return MainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      {/* FOR SEO */}
      <Helmet>
        <title>{product?.translations?.[lang]?.title}</title>
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      {/* FOR SEO */}
      <CoverBlock $cover={product?.photoUrl || ''}>
        <MobileCoverImg src={product?.photoUrl} alt="travel-cover-mobile-image" />
        <Container
          style={{
            height: 'inherit',
          }}
        >
          <CoverSectionDiv>
            <h2>{product?.translations?.[lang]?.title}</h2>
            <p dangerouslySetInnerHTML={{ __html: product?.translations?.[lang]?.description || '' }}></p>
            {type === 'critical' || type === 'casco' || type === 'health' || type === 'property' ? null : (
              <Button
                type="button"
                buttonType="primary"
                onClick={() => {
                  if (type === 'travel') {
                    navigate(`/single-select-date`)
                    //
                  } else if (type === 'tpl') {
                    navigate(`/tpl-choose-days`)
                    //
                  } else if (type === 'international-tpl') {
                    navigate('/international-tpl-country')
                    //
                  } else if (type === 'health') {
                    navigate('/health-compare-companies')
                    //
                  } else if (type === 'welcomer') {
                    navigate('/welcomer-start-date')
                    //
                  } else if (type === 'pet') {
                    navigate('/choose-pet')
                  }
                }}
                text={`${t('priceCalculation')}`}
                disabled={false}
              />
            )}
          </CoverSectionDiv>
        </Container>
      </CoverBlock>

      {type === 'critical' || type === 'casco' || type === 'health' || type === 'property' ? (
        <ServiceSection>
          <ReplacedContainer>
            <Service>
              <Swiper
                breakpoints={brakePoints}
                slidesPerView="auto"
                scrollbar={{ draggable: true }}
                modules={[Autoplay, A11y, Navigation]}
                loop={product?.companies && product.companies.length > 1}
                navigation={{
                  enabled: true,
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                }}
                autoplay={{
                  delay: 4000,
                  pauseOnMouseEnter: true,
                  disableOnInteraction: true,
                }}
              >
                {product?.companies &&
                  product.companies.map((item, index) => {
                    return (
                      <Card key={index}>
                        <SwiperSlide key={index}>
                          <CompanyCard
                            key={index}
                            onClick={() => {
                              setIsAiModalCardVisible(true)
                            }}
                            title={item?.[lang]?.title || ''}
                            imgUrl={item?.[lang]?.imageUrl || ''}
                            policyUrl={item?.[lang]?.policyUrl || ''}
                          />
                        </SwiperSlide>
                      </Card>
                    )
                  })}
              </Swiper>
              <NavigationButtons>
                <NavButton className="swiper-button-prev">
                  <ShortLeftArrow />
                </NavButton>

                <NavButton className="swiper-button-next">
                  <ShortRightArrow />
                </NavButton>
              </NavigationButtons>
            </Service>
          </ReplacedContainer>
        </ServiceSection>
      ) : null}

      {product && companies && companies.length > 0 ? (
        <CompanyBlock>
          <Container>
            <CompaniesContent>
              <h3>{product?.companyProfile?.[lang]?.title}</h3>
              <p>{product?.companyProfile?.[lang]?.description}</p>
              <CompanyLogos>
                {companies?.map((item, index) => (
                  <img key={`${index + 1}-company-logo`} src={item?.cover} alt={`company-icon-${index}`} />
                ))}
              </CompanyLogos>
            </CompaniesContent>
          </Container>
        </CompanyBlock>
      ) : null}

      <CoveredBlock>
        <Container>
          {type === 'travel' || type === 'welcomer' ? (
            <div>
              <CoveredTitle>{product?.risks?.translations?.[lang]?.coveredTitle}</CoveredTitle>
              <CoveredContent>
                {product?.risks?.covered?.map((item, index) => (
                  <Covered key={index}>
                    <CoveredImage src={item?.icon} alt={`covered-img-${index}`} />

                    <CoveredName>{item?.translations?.[lang]?.title}</CoveredName>

                    <CoveredDescription>{item?.translations?.[lang]?.description}</CoveredDescription>

                    <CustomLink
                      onClick={() => setSelectedCovered(item?.travelRiskId)}
                      text={t('inDetails')}
                      rightLineIcon={false}
                    />

                    <VerticalBorder />
                  </Covered>
                ))}
              </CoveredContent>
            </div>
          ) : null}

          {type === 'tpl' ||
          type === 'pet' ||
          type === 'international-tpl' ||
          type === 'critical' ||
          type === 'casco' ||
          type === 'property' ||
          type === 'health' ? (
            <NotCoveredBlock>
              <MessageBox>
                <MessageContent>
                  <MessageHead>
                    <span>{product?.risks?.translations?.[lang]?.coveredTitle}</span>
                  </MessageHead>
                  {product?.risks?.covered?.map((item, index) => (
                    <MessageText key={index}>
                      <DoubleRightIcon /> <span>{item?.translations?.[lang]?.description}</span>
                    </MessageText>
                  ))}
                </MessageContent>
              </MessageBox>
            </NotCoveredBlock>
          ) : null}

          <HRL />

          <NotCoveredBlock>
            <MessageBox>
              <MessageContent>
                <MessageHead>
                  <span>{product?.risks?.translations?.[lang]?.notCoveredTitle}</span>
                </MessageHead>
                {product?.risks?.notCovered?.map((item, index) => (
                  <MessageText key={index}>
                    <DoubleRightIcon /> <span>{item?.translations?.[lang]?.description}</span>
                  </MessageText>
                ))}
              </MessageContent>
            </MessageBox>
          </NotCoveredBlock>
        </Container>
      </CoveredBlock>
      {/* covered modal */}
      <BaseModal isOpen={selectedCovered ? true : false} onClose={() => setSelectedCovered(null)}>
        {product?.risks?.covered?.find((x) => x?.travelRiskId === selectedCovered)?.translations?.[lang]?.description}
      </BaseModal>
      {/* covered modal */}

      <AiModalCard
        visible={isAiModalCardVisible}
        onClose={() => {
          setIsAiModalCardVisible(false)
        }}
        onStartChat={() => {
          setIsAiModalCardVisible(false)
          navigate('/ai-assistent')
        }}
      />
    </Wrapper>
  )
}
//

const ReplacedContainer = styled(Container)`
  position: relative;

  ${Responsive.tablet} {
    max-width: unset;
    margin-left: 48px;
    margin-right: unset;
  }

  ${Responsive.mobile} {
    max-width: unset;
    margin-right: unset;
  }
`

const ServiceSection = styled.section`
  background-color: ${Colors.Alabaster};
  position: relative;

  ${Responsive.mobile} {
    padding-top: 0;
    padding-bottom: 40px;
  }
`

const NavButton = styled.div`
  /*  */
`

const NavigationButtons = styled.div`
  .swiper-button-prev,
  .swiper-button-next {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background-color: ${Colors.white};
    box-shadow: 0 4px 50px 0 rgba(0, 0, 0, 0.04);
    cursor: pointer;

    svg {
      color: ${Colors.nevadaGrey};
      height: 18px;
    }
  }

  ${Responsive.tablet} {
    display: none;
  }

  ${Responsive.mobile} {
    display: none;
  }
`

const Card = styled.div`
  ${Responsive.tablet} {
    max-width: unset;
  }
`

const Service = styled.div`
  width: 100%;
  padding-inline: 96px;

  .swiper-slide {
    height: unset;
  }

  .swiper-button-prev,
  .swiper-button-next {
    z-index: 5 !important;
  }

  .swiper-button-prev::after {
    display: none;
  }
  .swiper-button-next::after {
    display: none;
  }

  ${Responsive.tablet} {
    padding-inline: 16px;
    width: 100%;
    .swiper-slide {
      width: unset;
      margin-right: 16px;
    }

    .service-card {
      width: 296px;
    }
  }

  ${Responsive.mobile} {
    padding-inline: 8px;
    width: 100%;
    .swiper-slide {
      width: unset;
      margin-right: 8px;
    }

    .service-card {
      width: 240px;
    }
  }
`

const CompanyItemLink = styled(Link)`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  opacity: 1;
  cursor: pointer;
  padding-top: 5px;
  padding-bottom: 5px;
  margin-top: 3px;
  margin-bottom: 3px;
  text-decoration: none;
  transition: all 200ms ease-in-out;
  &:hover {
    transition: all 100ms ease-in-out;
    color: ${Colors.primaryGrey};
    opacity: 0.8;
  }
  ${Responsive.mobile} {
    padding-top: 2px;
    padding-bottom: 2px;
    margin-top: 1px;
    margin-bottom: 1px;
  }
`

const MessageText = styled.div`
  font-size: 14px;
  color: ${Colors.primaryBlack};
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  /*  */
  &:last-child {
    margin-bottom: 0px;
  }

  /* message text span */
  span {
    margin-left: 15px;
    color: ${Colors.primaryGrey};
  }

  /* message checkmark icon & svg */
  svg {
    min-width: 20px;
    width: 20px;
    height: 20px;
    margin-left: -3px;
    color: ${Colors.primaryGrey};
  }

  /*  */
  ${Responsive.mobile} {
    /* message checkmark icon & svg */
    svg {
      margin-left: 0px;
      min-width: 15px;
      width: 15px;
    }

    /* message text span */
    span {
      margin-left: 20px;
      color: ${Colors.primaryGrey};
      line-height: 20px;
    }
  }
`
const MessageHead = styled.div`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  display: flex;
  align-items: center;
  margin-bottom: 18px;

  ${Responsive.mobile} {
    font-size: 14px;
    margin-bottom: 15px;

    /* message text span */
    span {
      margin-left: 5px;
    }
  }
`
const MessageContent = styled.div`
  margin-bottom: 33px;
`
const MessageBox = styled.div``
const HRL = styled.div`
  height: 1px;
  background-color: ${Colors.secondaryGrey};
  margin-block: 50px;

  ${Responsive.mobile} {
    margin-block: 25px;
  }
`
//
const CoveredDescription = styled.p`
  font-size: 14px;
  color: ${Colors.primaryGrey};
  font-weight: normal;
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`
const CoveredName = styled.div`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  font-weight: normal;
  margin-bottom: 20px;
  text-align: center;
`
const VerticalBorder = styled.div`
  background-color: ${Colors.secondaryGrey};
  width: 1px;
  height: 140px;
  position: absolute;
  left: -50px;
  display: none;
  ${Responsive.mobile} {
    display: none;
  }
`
const CoveredImage = styled.img`
  min-height: 40px;
  height: 40px;
  width: 48px;
  margin-bottom: 20px;
  object-fit: contain;
`
const CoveredContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 100px 100px;
  ${Responsive.mobile} {
    gap: 20px 20px;
    justify-content: space-around;
  }
`
const CoveredTitle = styled.h3`
  text-align: center;
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 60px;
`
const CompanyLogos = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 80px 50px;
  justify-items: stretch;

  /*  */
  img {
    height: 56px;
    object-fit: contain;
  }

  ${Responsive.laptop} {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  }

  ${Responsive.tablet} {
    grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
    gap: 60px 50px;
  }

  ${Responsive.mobile} {
    grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
    gap: 40px 20px;

    img {
      height: 40px;
    }
  }
`
const CompaniesContent = styled.div`
  h3 {
    font-size: 36px;
    color: ${Colors.primaryBlack};
    text-align: center;
    margin-bottom: 25px;
  }
  /*  */
  p {
    font-size: 18px;
    color: ${Colors.nevadaGrey};
    text-align: center;
    margin-bottom: 80px;
    max-width: 45%;
    margin-inline: auto;
  }

  ${Responsive.tablet} {
    p {
      max-width: unset;
      margin-bottom: 70px;
    }
  }

  ${Responsive.mobile} {
    h3 {
      font-size: 18px;
      margin-bottom: 12px;
    }

    p {
      font-size: 12px;
      max-width: unset;
      margin-bottom: 45px;
    }
  }
`
const MobileCoverImg = styled.img`
  display: none;
  width: 100%;

  ${Responsive.tablet} {
    display: block;
  }

  ${Responsive.mobile} {
    display: block;
  }
`

const CoverSectionDiv = styled.div`
  width: 40%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;

  h2 {
    font-size: 36px;
    color: ${Colors.primaryBlack};
    margin-bottom: 40px;
  }

  p {
    font-size: 18px;
    color: ${Colors.nevadaGrey};
    margin-bottom: 20px !important;

    :last-of-type {
      margin-bottom: 48px;
    }
  }

  ${Responsive.tablet} {
    width: 100%;
    align-items: center;
    text-align: center;
    margin-top: 20px;

    h2 {
      font-size: 18px;
      margin-bottom: 24px;
    }

    p {
      font-size: 14px;

      :last-of-type {
        margin-bottom: 40px;
      }
    }

    button {
      width: 100%;
    }
  }

  ${Responsive.mobile} {
    width: 100%;
    align-items: center;
    text-align: center;
    margin-top: 20px;

    h2 {
      font-size: 18px;
      margin-bottom: 24px;
    }

    p {
      font-size: 14px;

      :last-of-type {
        margin-bottom: 40px;
      }
    }

    button {
      width: 100%;
    }
  }
`
const NotCoveredBlock = styled.div`
  background-color: ${Colors.backgroundGrey};
`
const CoveredBlock = styled.div`
  background-color: ${Colors.backgroundGrey};
  padding-block: 120px;

  ${Responsive.mobile} {
    padding-block: 56px;
  }
`
const Covered = styled.div`
  width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  a {
    span {
      text-decoration: underline;
    }
  }

  &:first-child {
    ${VerticalBorder} {
      display: none;
    }
  }

  ${Responsive.desktop} {
    &:nth-child(3n) {
      ${VerticalBorder} {
        display: block;
      }
    }
    &:nth-child(3n - 1) {
      ${VerticalBorder} {
        display: block;
      }
    }
  }
  /* responsive */
  ${Responsive.laptop} {
    width: 300px;
    &:nth-child(3n) {
      ${VerticalBorder} {
        display: block;
      }
    }
    &:nth-child(3n - 1) {
      ${VerticalBorder} {
        display: block;
      }
    }
  }
  ${Responsive.tablet} {
    width: 300px;
    /*  */
    &:nth-child(2n) {
      ${VerticalBorder} {
        display: block;
      }
    }
  }
  ${Responsive.mobile} {
    width: 150px;
    /*  */
    &:nth-child(2n) {
      ${VerticalBorder} {
        display: none;
      }
    }
  }
`
const CompanyBlock = styled.div`
  background-color: ${Colors.white};
  padding-block: 80px;

  ${Responsive.mobile} {
    padding-block: 50px;
  }
`
const CoverBlock = styled.div<{ $cover: string }>`
  background-color: ${Colors.backgroundGrey};
  background-image: url(${(props) => props.$cover});
  background-position: top right;
  background-repeat: no-repeat;
  height: 740px;

  ${Responsive.tablet} {
    background-image: none;
    height: fit-content;
  }

  ${Responsive.mobile} {
    background-image: none;
    height: fit-content;
  }
`
const Wrapper = styled.div``
//
export default ProductDetail
